// extracted by mini-css-extract-plugin
export var bodyRow = "_ct-d";
export var cardColumns = "_ct-e";
export var ellipsesOverflow = "_ct-2";
export var flatBottomCorners = "_ct-3";
export var flatTopCorners = "_ct-4";
export var headerActionsDropdown = "_ct-f";
export var headerBottomRow = "_ct-c";
export var headerTopRow = "_ct-b";
export var orderDetailsWrapper = "_ct-0";
export var orderInfoContainer = "_ct-1";
export var productDetails = "_ct-9";
export var productImage = "_ct-5";
export var responsiveTable = "_ct-8";
export var shipmentContainer = "_ct-a";
export var tableBottomLeft = "_ct-6";
export var tableBottomRight = "_ct-7";
export var trackingLink = "_ct-g";